import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Ref } from 'vue';
import type { ConfirmDialogParam } from '@/types/models/common.d';

export const useConfirmDialogStore = defineStore('confirmDialog', () => {
  /** 現在表示中の確認ダイアログ。undefinedなら非表示 */
  const confirmDialogParam: Ref<ConfirmDialogParam | undefined> = ref(undefined);

  return { confirmDialogParam };
});
